import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { WSProvider } from './contexts/WSContext';

import DeliveryLogin from './pages/delivery/DeliveryLogin';
import DeliveryRegister from './pages/delivery/DeliveryRegister';
import DeliveryDashboard from './pages/delivery/DeliveryDashboard';
import DeliveryActive from './pages/delivery/DeliveryActive';
import DeliveryEarnings from './pages/delivery/DeliveryEarnings';
import DeliveryBrands from './pages/delivery/DeliveryBrands';

function Guard({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="mobile-shell flex items-center justify-center">
      <img src="/logo.png" alt="logo" className="w-24 h-24 object-contain animate-bounce" />
    </div>
  );
  if (!user) return <Navigate to="/entregador/login" replace />;
  if (user.role !== 'delivery') {
    localStorage.removeItem('token');
    return <Navigate to="/entregador/login" replace />;
  }
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <div className="mobile-shell">
      <Toaster position="top-center" toastOptions={{ style: { fontSize: 14, borderRadius: 12 } }} />
      <Routes>
        <Route path="/" element={
          user && user.role === 'delivery'
            ? <Navigate to="/entregador/dashboard" replace />
            : <Navigate to="/entregador/login" replace />
        } />
        <Route path="/entregador/login" element={<DeliveryLogin />} />
        <Route path="/entregador/register" element={<DeliveryRegister />} />
        <Route path="/entregador/dashboard" element={<Guard><DeliveryDashboard /></Guard>} />
        <Route path="/entregador/entrega/:orderId" element={<Guard><DeliveryActive /></Guard>} />
        <Route path="/entregador/ganhos" element={<Guard><DeliveryEarnings /></Guard>} />
        <Route path="/entregador/marcas" element={<Guard><DeliveryBrands /></Guard>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <WSProvider>
          <AppRoutes />
        </WSProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
